/* eslint-disable
    func-names,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const MessageParser = require('event-feed/util/MessageParser').default;

const deps = [];

module.exports = angular
  .module('data.service.messageParser', deps)
  .factory('MessageParser', () => MessageParser);
